import { Component, OnInit, AfterContentInit, ViewChild, ElementRef } from '@angular/core'
import { InputBaseComponent } from '../input-base.component';
declare var $: any;
@Component({
  selector: 'ct-input-number',
  templateUrl: './ct-input-number.component.html',
  styleUrls: ['./ct-input-number.component.css']
})

export class CtInputNumberComponent extends InputBaseComponent implements OnInit {
  @ViewChild('el') formControl: ElementRef;

  private Inputlength: number;
  private lengthDecimals: number;
  private symbol: string;
  public decimalSeparator: string;
  public thousandSeparator: string;
  private min: string;
  private max: string;
  public mask: string = '';
  public prefix: string = '';
  public suffix: string = '';
  listenedProperty: any;
  listenedComponentId: any;

  public textOrientation: string = "left"

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.createMask();
  }


  ngAfterViewInit() {
    this.setInitValue(this.getValue());
  }
  

  public setReadOnly(readOnly: boolean): void {
    super.setReadOnly(readOnly);
    this.formControl.nativeElement.readOnly = readOnly;
}

  getLength(): number { return this.Inputlength }
  getLengthDecimals(): number { return this.lengthDecimals }
  getSymbol(): string { return this.symbol }
  getDecimalSeparator(): string { return this.decimalSeparator }
  getThousandSeparator(): string { return this.thousandSeparator }
  getMin(): string { return this.min }
  getMax(): string { return this.max }
  getValue(): string {
    let currentValue = super.getValue();

    if (!currentValue || currentValue == 0)
      return null;
    return currentValue.toString().replace(this.getSymbol() === '*#' ? /[^\w\s\.]/gi : /[^\w\s\.-]/gi, '');
  }
  getFormControl(): any { return this.formControl }


  setLength(length: number): void { this.Inputlength = length }
  setLengthDecimals(decimalLength: number): void { this.lengthDecimals = decimalLength }
  setSymbol(symbol: string): void { this.symbol = symbol }
  setDecimalSeparator(decimalSeparator: string): void { this.decimalSeparator = decimalSeparator }
  setThousandSeparator(thousandSeparator: string): void { this.thousandSeparator = thousandSeparator }
  setMin(min: string): void { this.min = min }
  setMax(max: string): void { this.max = max }
  getTextOrientation():string { return this.textOrientation };
  
  setTextOrientation(textOrientation: string): void { this.textOrientation = textOrientation }

  createMask() {
    //prefix(string): what to display before the amount.Defaults to '$'.
    //suffix(string): what to display after the amount.Defaults to empty string.
    //includeThousandsSeparator(boolean): whether or not to separate thousands.Defaults to to true.
    //thousandsSeparatorSymbol(string): character with which to separate thousands.Default to ','.
    //allowDecimal(boolean): whether or not to allow the user to enter a fraction with the amount.Default to false.
    //decimalSymbol(string): character that will act as a decimal point.Defaults to '.'
    //decimalLimit(number): how many digits to allow after the decimal.Defaults to 2
    //integerLimit(number): limit the length of the integer number.Defaults to null for unlimited
    //requireDecimal (boolean): whether or not to always include a decimal point and placeholder for decimal digits after the integer.Defaults to false.
    //allowNegative(boolean): whether or not to allow negative numbers.Defaults to false
    //allowLeadingZeroes(boolean): whether or not to allow leading zeroes.Defaults to false

    switch (this.getSymbol()) {

      case 'CRC':
        this.prefix = '₡'
        this.mask = 'separator.' + (this.getLengthDecimals() && this.getLengthDecimals() != 0 ? + this.getLengthDecimals() : 2)
        break;

      case 'USD':
        this.prefix = '$'
        this.mask = 'separator.' + (this.getLengthDecimals() && this.getLengthDecimals() != 0 ? + this.getLengthDecimals() : 2)

        break;


      case '%':
        this.suffix = '%'
        this.mask = 'percent'
        break;

      case '*#':
        this.mask = '0000-0000'
        break;

      case '#':
      default:
        this.mask = '0{' + this.getLength() + '}'
        break;

    }
  }

}
